import styled from 'styled-components';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Warning, MAX_SM, MIN_MD } from '@silverrailtech/srtlibrary';
import { whiteSmoke, limeGreen, darkGray } from '../../../../colors';

export const PageHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 24px 0;

	h1 {
		margin: 0;
	}

	@media screen and (max-width: ${MAX_SM}) {
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
	}
`;

export const SearchFormWrapper = styled.div`
	&& {
		padding: 16px;
		border-radius: 6px;
		background-color: #fff;
		box-shadow: 0px 0px 4px rgba(51, 153, 255, 0.5);
		border: 1px solid #dce2e6;

		.MuiFormControl-root.MuiTextField-root {
			margin-top: 0 !important;
		}
	}
`;

export const SplitRow = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 4px;
	align-items: center;
	padding: ${(props) => props.padding || '8px 0'};

	@media screen and (max-width: ${MAX_SM}) {
		grid-template-columns: 1fr;
	}
`;

export const SplitCol = styled.div.withConfig({
	shouldForwardProp: (prop) => !['hideOnSmall'].includes(prop),
})`
	box-sizing: border-box;
	padding: 0 8px;
	@media screen and (max-width: ${MAX_SM}) {
		${(props) => props.hideOnSmall && `display: none;`}
	}
`;

export const SearchTooltipWrapper = styled.div`
	position: relative;
	margin-top: 20px;
`;

export const Tooltip = styled.div`
	width: 100%;
	padding: 8px 16px;
	background: #f5f7fa;
	border-radius: 4px;

	&::after {
		content: '';
		position: absolute;
		left: -16px;
		top: 50%;
		transform: translateY(-50%);
		border: 8px solid transparent;
		border-right-color: #f5f7fa;
		z-index: 11;
	}
`;

export const SearchButtonWrapper = styled.div`
	display: flex;
	justify-content: center;

	width: 50%;
	margin: 20px auto 0 auto;
`;

export const EmailWarning = styled(Warning)`
	padding: 7px 9px;
`;

export const SearchModeTabsWrapper = styled.div`
	margin-bottom: 16px;
`;

export const StyledTabs = styled(Tabs)`
	background-color: ${whiteSmoke};
	font-size: 14px;

	& .MuiTabs-indicator {
		background-color: ${limeGreen};
	}
`;

export const StyledTab = styled(Tab)`
	&& {
		padding: 6px 24px;
		color: ${darkGray};

		@media screen and (min-width: ${MIN_MD}) {
			min-width: 0;
			font-size: 14px;
		}
	}
`;
